import styled from "styled-components";

/**
 * Styled components used for all the project setup flows
 */

export const Container = styled.div`
  overflow: hidden;
  display: flex;
  padding: 60px 40px;
  height: 100%;
`;

export const LeftPane = styled.div`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: auto 0;
  gap: 16px;
  width: clamp(400px, 40%, 500px);
  max-height: 100%;
  // don't shrink
  flex-shrink: 0;
  padding: 20px 60px 40px;
`;

export const Divider = styled.div`
  height: 100%;
  width: 2px;
  background-color: var(--light-gray1);
`;

export const RightPane = styled.div`
  max-height: 100%;
  overflow-y: auto;
  padding: 20px 60px;
  margin: auto 0;
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

export const Title = styled.div`
  font-size: var(--global-font-size-xl);
`;

export const ErrorText = styled.div`
  color: var(--global-red);
  // change styling of links so they're not purple
  & a {
    text-decoration: underline;
    :hover {
      text-decoration: none;
    }
    color: var(--global-red);
  }
`;

/**
 * For use within a step item
 * To use, set max-height to something larger than necessary and margin to 0
 */
export const SlideOpen = styled.div`
  // TODO this currently only transitions on open, not close
  max-height: 0px;
  transition: max-height 0.5s ease-out;
  overflow: hidden;
  width: 100%;
  // to negate the space between elements in the step item
  margin-top: -16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
